import { kUserFilesApiBasePath } from '@/constants/constants-api-paths'
import { kUserFilesMoveMaxFileIds, kUserFilesMoveMaxFolderIds } from '@/user_files/limits'

export const kUserFilesMoveApiBasePath = `${kUserFilesApiBasePath}/move`

// Backend request limits
export const kMoveMaxFileIdsPerRequest = kUserFilesMoveMaxFileIds
export const kMoveMaxFolderIdsPerRequest = kUserFilesMoveMaxFolderIds
